(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["countdown"] && !Shopify.designMode) return;
  try {
     
class FilpClock extends HTMLElement {
  constructor() {
    super();
    this.targetDate = new Date(this.getAttribute('data-countdown-input')).getTime();
    this.flipclock = this.querySelectorAll('[data-flip-clock]');
    this.timer_labels = {
      days: this.querySelector('[data-days]'),
      hours: this.querySelector('[data-hours]'),
      minutes: this.querySelector('[data-minutes]'),
      seconds: this.querySelector('[data-seconds]'),
    };
    const currentDate = new Date().getTime();
    this.remainingTime = this.targetDate - currentDate;
    var time = this.timeDifference(currentDate, this.targetDate);
    if (this.remainingTime <= 0) {

       const mainElement = this.closest('.shopify-section');
      if(this.getAttribute('data-timeout-style') == 'show')
      {
        
        mainElement.querySelector('[data-message]').classList.remove('hidden');
        mainElement.querySelector('filpclock-counter').style.display = 'none';
      }

      if(this.getAttribute('data-timeout-style') == 'hide'){
          mainElement.querySelector('filpclock-counter').style.display = 'none';
      }

      return;
    }
    
   
   
    if ('IntersectionObserver' in window === false) return;
    const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
        if (entry.isIntersecting) {
          this.initializeClock();
          observer.unobserve(this);
        }
    });
    }, { rootMargin: '0px 0px 700px 0px' });
    observer.observe(this);


    this.flipclock.forEach((flipClock) => { 
  var daysFirst = flipClock.querySelector('[data-days-first]');
  var hoursFirst = flipClock.querySelector('[data-hours-first]');
  var minutesFirst = flipClock.querySelector('[data-minutes-first]');
  var secondsFirst = flipClock.querySelector('[data-seconds-first]');


  if (daysFirst) {
    daysFirst.querySelector('[data-day]').value = time.days;
    daysFirst.querySelectorAll('[data-day-top]').forEach((element) => {
      element.textContent = time.days; 
    });
    daysFirst.querySelectorAll('[data-day-bottom]').forEach((element) => {
      element.textContent = time.days; 
    });
  }

  if (hoursFirst) {
    hoursFirst.querySelector('[data-hour]').value = time.hours;
    hoursFirst.querySelectorAll('[data-hour-top]').forEach((element) => {
      element.textContent = time.hours; 
    });
    hoursFirst.querySelectorAll('[data-hour-bottom]').forEach((element) => {
      element.textContent = time.hours; 
    });
  }

  if (minutesFirst) {
    minutesFirst.querySelector('[data-minute]').value = time.minutes;
    minutesFirst.querySelectorAll('[data-minute-top]').forEach((element) => {
      element.textContent = time.minutes; // Update top text for minutes
    });
    minutesFirst.querySelectorAll('[data-minute-bottom]').forEach((element) => {
      element.textContent = time.minutes; // Update bottom text for minutes
    });
  }

  if (secondsFirst) {
    secondsFirst.querySelector('[data-second]').value = time.seconds;
    secondsFirst.querySelectorAll('[data-second-top]').forEach((element) => {
      element.textContent = time.seconds; // Update top text for seconds
    });
    secondsFirst.querySelectorAll('[data-second-bottom]').forEach((element) => {
      element.textContent = time.seconds; // Update bottom text for seconds
    });
  }

});


  }

  initializeClock() {
  this.flipclock.forEach((flipClock) => { // Changed function to arrow function

    var daysFirst = this.createHandles(flipClock.querySelector('[data-days-first]'));
    var hoursFirst = this.createHandles(flipClock.querySelector('[data-hours-first]'));
    var minutesFirst = this.createHandles(flipClock.querySelector('[data-minutes-first]'));
    var secondsFirst = this.createHandles(flipClock.querySelector('[data-seconds-first]'));

    function updateClock() {
      var time = this.timeDifference(currentDate, this.targetDate); // Ensure 'this' refers to FilpClock instance
    

      this.flipDigit(daysFirst, Math.floor(time.days));

      this.flipDigit(hoursFirst, Math.floor(time.hours ));

      this.flipDigit(minutesFirst, Math.floor(time.minutes));
      this.flipDigit(secondsFirst, Math.floor(time.seconds));
   
      this.querySelector('[data-day]').value = time.days;
      this.querySelector('[data-hour]').value = time.hours;
      this.querySelector('[data-minute]').value = time.minutes;
      this.querySelector('[data-second]').value = time.seconds;
      
      if (time.total <= 0) {
        const mainElement = this.closest('.shopify-section');
      if(this.getAttribute('data-timeout-style') == 'show')
      {
        
        mainElement.querySelector('[data-message]').classList.remove('hidden');
        mainElement.querySelector('filpclock-counter').style.display = 'none';
      }

      if(this.getAttribute('data-timeout-style') == 'hide'){
          mainElement.querySelector('filpclock-counter').style.display = 'none';
      }

      return;
      
        clearInterval(timeinterval);
      }
    }
    var currentDate = new Date().getTime(); // Define currentDate here
    var timeinterval = setInterval(updateClock.bind(this), 1000); // Bind updateClock to FilpClock instance
    });
  }


  timeDifference(current, target) {
    const currentDate = new Date().getTime();
    this.remainingTime = this.targetDate - currentDate;
    const days = Math.floor(this.remainingTime / (1000 * 60 * 60 * 24));
    const hours = Math.floor((this.remainingTime % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((this.remainingTime % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((this.remainingTime % (1000 * 60)) / 1000);

    return {
      'total': this.remainingTime,
      'days': days,
      'hours': hours,
      'minutes': minutes,
      'seconds': seconds
    };
  }

  createHandles(flipElement) {
    var flipperTop = flipElement.querySelector("[flipper-top]");
    var flipperBottom = flipElement.querySelector("[flipper-bottom]");
    var flipperDisplayTop = flipElement.querySelector("[flip-display-top]");
    var flipperDisplayBottom = flipElement.querySelector("[flip-display-bottom]");
    var flipHiddenInput = flipElement.querySelector("[type='hidden']");
    return {
      flipElement,
      flipperTop,
      flipperBottom,
      flipperDisplayBottom,
      flipperDisplayTop,
      flipHiddenInput,
    };
  }

  flipDigit(flipHandles, digitValue) {
    var {
      flipElement,
      flipperTop,
      flipperBottom,
      flipperDisplayBottom,
      flipperDisplayTop,
      flipHiddenInput,
    } = flipHandles;

    var setPreviousValue = function(value) {
      flipperTop.innerText = value;
      flipperDisplayBottom.innerText = value;
    };
    var setAfterValue = function(value) {
      flipperDisplayTop.innerText = value;
      flipperBottom.innerText = value;
    };

    if (parseInt(flipHiddenInput.value) !== digitValue) {
      setPreviousValue(flipHiddenInput.value);
      flipHiddenInput.value = digitValue;
      var valueChangedEvent = new Event('valueChanged');
      flipHiddenInput.dispatchEvent(valueChangedEvent);
    }

    flipHiddenInput.addEventListener('valueChanged', function() {
      setAfterValue(flipHiddenInput.value);
      flipElement.classList.add("play");
    });

    flipperBottom.addEventListener('animationend', function() {
      setAfterValue(flipHiddenInput.value);
      setPreviousValue(flipHiddenInput.value);
      flipElement.classList.remove("play");
    });
  }
}
customElements.define('filpclock-counter', FilpClock);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-products"] && !Shopify.designMode) return;
  try {
     
class FeatureProducts extends HTMLElement {
  constructor() {
    super();
    window.addEventListener('scroll', this.onScroll.bind(this));
  }

  onScroll() {
    const currentSection = this.closest('.shopify-section');
    const offsetSection = currentSection.getBoundingClientRect();

    if (offsetSection.top < window.innerHeight && offsetSection.bottom > 70) {
      this.classList.add('is-active');
    }
  }
}

customElements.define('feature-products', FeatureProducts);



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["filters-new"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (window.CollectionFilterDialogs) {
    window.CollectionFilterDialogs.mount();
    return;
  }

  const states = new WeakMap();
  let activeDialog = null;

  const closeDrawer = (state) => {
    if (state.panel.open) state.panel.close();
  };

  const mount = () => {
    document.querySelectorAll('[data-mfd-section]').forEach((root) => {
      if (states.has(root)) return;
      const panel = root.querySelector('.mfd__panel');
      const form = root.querySelector('.mfd__form');
      const countNode = root.querySelector('[data-mfd-count]');
      if (!panel || !form) return;
      const state = { root, panel, form, trigger: null };
      states.set(root, state);

      panel.addEventListener('close', () => {
        document.body.classList.remove('mfd-lock');
        if (state.trigger && state.trigger.isConnected) {
          state.trigger.setAttribute('aria-expanded', 'false');
          state.trigger.focus({ preventScroll: true });
        }
        if (activeDialog === state) activeDialog = null;
      });

      panel.addEventListener('click', (event) => {
        if (event.target !== panel) return;
        const rect = panel.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right ||
            event.clientY < rect.top || event.clientY > rect.bottom) closeDrawer(state);
      });

      root.querySelector('.mfd__close').addEventListener('click', () => closeDrawer(state));

      root.querySelectorAll('.mfd__accordion-trigger').forEach((button) => {
        button.addEventListener('click', () => {
          const group = document.getElementById(button.getAttribute('aria-controls'));
          const expanded = button.getAttribute('aria-expanded') === 'true';
          button.setAttribute('aria-expanded', String(!expanded));
          if (group) group.hidden = expanded;
        });
      });

      let requestNumber = 0;
      let timer;
      let aborter;

      const updateResultCount = async () => {
        const currentRequest = ++requestNumber;
        if (aborter) aborter.abort();
        aborter = new AbortController();
        const endpoint = new URL(form.action, window.location.origin);
        const params = new URLSearchParams(new FormData(form));
        for (const [key, value] of Array.from(params.entries())) {
          if (value === '') params.delete(key);
        }
        endpoint.search = params.toString();
        endpoint.searchParams.set('section_id', root.dataset.mfdId);

        try {
          const response = await fetch(endpoint.toString(), {
            headers: { 'X-Requested-With': 'XMLHttpRequest' },
            signal: aborter.signal
          });
          if (!response.ok) return;
          const result = new DOMParser().parseFromString(await response.text(), 'text/html');
          const nextCount = result.querySelector('[data-mfd-count]');
          if (nextCount && countNode && currentRequest === requestNumber && root.isConnected) {
            countNode.textContent = nextCount.textContent.trim();
          }
        } catch (error) {
          if (error.name !== 'AbortError') console.warn('Could not update filter result count.', error);
        }
      };

      form.addEventListener('change', () => {
        window.clearTimeout(timer);
        timer = window.setTimeout(updateResultCount, 180);
      });
      form.addEventListener('input', (event) => {
        if (event.target.type !== 'number') return;
        window.clearTimeout(timer);
        timer = window.setTimeout(updateResultCount, 180);
      });
      form.addEventListener('submit', () => {
        form.querySelectorAll('input[type="number"]').forEach((input) => {
          if (!input.value) input.disabled = true;
        });
      });
      state.cleanup = () => {
        window.clearTimeout(timer);
        if (aborter) aborter.abort();
        closeDrawer(state);
      };
    });
  };

  window.addEventListener('click', (event) => {
    const trigger = event.target instanceof Element && event.target.closest('[data-mfd-open]');
    if (!trigger) return;
    mount();
    const root = document.querySelector('[data-mfd-section]');
    const state = root && states.get(root);
    if (!state) {
      console.error('The custom filter drawer section is missing from this collection template.');
      return;
    }
    event.preventDefault();
    event.stopPropagation();
    if (activeDialog && activeDialog !== state) closeDrawer(activeDialog);
    state.trigger = trigger;
    trigger.setAttribute('aria-controls', state.panel.id);
    if (!state.panel.open) state.panel.showModal();
    trigger.setAttribute('aria-expanded', 'true');
    document.body.classList.add('mfd-lock');
    activeDialog = state;
  }, true);

  document.addEventListener('shopify:section:load', mount);
  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll('[data-mfd-section]').forEach((root) => {
      const state = states.get(root);
      if (state) state.cleanup();
      states.delete(root);
    });
  });

  window.CollectionFilterDialogs = { mount };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mount, { once: true });
  }
  mount();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const applyAccordionState = () => {
      const showAccordionOnMobile =
        document.querySelector('[data-show-accordion]')?.getAttribute('data-show-accordion') === 'true';
      const isMobile = window.matchMedia('(max-width: 767px)').matches;
      document.querySelectorAll('.section-footer details[data-accordion]').forEach((el) => {
        if (el.classList.contains('footer--about-menu')) {
          el.open = !isMobile;
          return;
        }
        if (showAccordionOnMobile && isMobile) {
          // Show accordion on mobile if setting allows
          el.removeAttribute('open', '');
        } else if (!showAccordionOnMobile && isMobile) {
          // Do not show accordion on mobile if setting disallows
          el.setAttribute('open',true);
        } else if (!isMobile) {
          // On desktop, always open accordions
          el.setAttribute('open', '');
          const getContent = el.querySelector('[data-collapsible-content]');
          if(getContent){
            getContent.style.opacity = '1';
          }
        }
      });
    };
    applyAccordionState();
    const mobileQuery = window.matchMedia('(max-width: 767px)');
    mobileQuery.addEventListener('change', () => {
      applyAccordionState();
    });
    document.addEventListener('shopify:section:load', (event) => {
      // Apply accordion state when a new section is loaded
      applyAccordionState();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class Sizechart extends HTMLElement {
    constructor() {
      super();
      this.querySelector('[data-size-chart]').addEventListener('click', this.init.bind(this));
    }

    init(e) {
      e.preventDefault();
      const popupModal = this.querySelector('popup-modal');
      popupModal.modalPopupOpen('data-size-chart-popup');
    }
  }
  customElements.define('size-chart', Sizechart);

  class ProgressBar extends HTMLElement {
    constructor() {
      super();
      this.init();
    }

    init() {
      this.style.setProperty(
        '--progress_width',
        `${(parseInt(this.dataset.value) * 0.75 * 100) / parseInt(this.dataset.max)}%`
      );
    }
  }
  customElements.define('progress-bar', ProgressBar);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mobile-new-filter"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (window.CollectionFilterDialogs) {
    window.CollectionFilterDialogs.mount();
    return;
  }

  const states = new WeakMap();
  let activeDialog = null;
  let editorDrawer = null;

  const cancelMotion = (state) => {
    if (!state.motion) return;
    state.motion.onfinish = null;
    state.motion.cancel();
    state.motion = null;
  };

  const reducedMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const closeDrawer = (state, immediate = false) => {
    if (!state.panel.open || (state.closing && !immediate)) return;
    const start = getComputedStyle(state.panel).transform;
    cancelMotion(state);
    state.closing = true;
    if (immediate || reducedMotion() || !state.panel.animate) {
      state.panel.close();
      return;
    }
    const motion = state.panel.animate([
      { transform: start },
      { transform: 'translateX(-100%)' }
    ], { duration: 240, easing: 'cubic-bezier(.4, 0, 1, 1)', fill: 'forwards' });
    state.motion = motion;
    motion.onfinish = () => {
      if (state.motion !== motion) return;
      state.panel.close();
    };
  };

  const openDrawer = (state, trigger, animate = true) => {
    const wasOpen = state.panel.open;
    const wasClosing = state.closing;
    const start = wasOpen ? getComputedStyle(state.panel).transform : 'translateX(-100%)';
    cancelMotion(state);
    state.closing = false;
    if (activeDialog && activeDialog !== state) closeDrawer(activeDialog, true);
    state.trigger = trigger;
    if (trigger) {
      trigger.setAttribute('aria-controls', state.panel.id);
      trigger.setAttribute('aria-expanded', 'true');
    }
    if (!wasOpen) state.panel.showModal();
    document.body.classList.add('mfd-lock');
    activeDialog = state;
    if (animate && (!wasOpen || wasClosing) && !reducedMotion() && state.panel.animate) {
      const motion = state.panel.animate([
        { transform: start },
        { transform: 'translateX(0)' }
      ], { duration: 320, easing: 'cubic-bezier(.22, .61, .36, 1)', fill: 'forwards' });
      state.motion = motion;
      motion.onfinish = () => {
        if (state.motion === motion) cancelMotion(state);
      };
    }
  };

  const mount = () => {
    document.querySelectorAll('[data-mfd-section]').forEach((root) => {
      if (states.has(root)) return;
      const panel = root.querySelector('.mfd__panel');
      const form = root.querySelector('.mfd__form');
      const countNode = root.querySelector('[data-mfd-count]');
      if (!panel || !form) return;
      const state = { root, panel, form, trigger: null, motion: null, closing: false };
      states.set(root, state);

      panel.addEventListener('close', () => {
        if (panel.open) return;
        cancelMotion(state);
        state.closing = false;
        if (activeDialog === state) {
          activeDialog = null;
          document.body.classList.remove('mfd-lock');
        }
        if (state.trigger && state.trigger.isConnected &&
            (!activeDialog || activeDialog.trigger !== state.trigger)) {
          state.trigger.setAttribute('aria-expanded', 'false');
          state.trigger.focus({ preventScroll: true });
        }
      });

      panel.addEventListener('cancel', (event) => {
        event.preventDefault();
        closeDrawer(state);
      });

      panel.addEventListener('click', (event) => {
        if (event.target !== panel) return;
        const rect = panel.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right ||
            event.clientY < rect.top || event.clientY > rect.bottom) closeDrawer(state);
      });

      root.querySelector('.mfd__close').addEventListener('click', () => closeDrawer(state));

      root.querySelectorAll('.mfd__accordion-trigger').forEach((button) => {
        button.addEventListener('click', () => {
          const group = document.getElementById(button.getAttribute('aria-controls'));
          const expanded = button.getAttribute('aria-expanded') === 'true';
          button.setAttribute('aria-expanded', String(!expanded));
          if (group) group.hidden = expanded;
        });
      });

      let requestNumber = 0;
      let timer;
      let aborter;

      const updateResultCount = async () => {
        const currentRequest = ++requestNumber;
        if (aborter) aborter.abort();
        aborter = new AbortController();
        const endpoint = new URL(form.action, window.location.origin);
        const params = new URLSearchParams(new FormData(form));
        for (const [key, value] of Array.from(params.entries())) {
          if (value === '') params.delete(key);
        }
        endpoint.search = params.toString();
        endpoint.searchParams.set('section_id', root.dataset.mfdId);

        try {
          const response = await fetch(endpoint.toString(), {
            headers: { 'X-Requested-With': 'XMLHttpRequest' },
            signal: aborter.signal
          });
          if (!response.ok) return;
          const result = new DOMParser().parseFromString(await response.text(), 'text/html');
          const nextCount = result.querySelector('[data-mfd-count]');
          if (nextCount && countNode && currentRequest === requestNumber && root.isConnected) {
            countNode.textContent = nextCount.textContent.trim();
          }
        } catch (error) {
          if (error.name !== 'AbortError') console.warn('Could not update filter result count.', error);
        }
      };

      form.addEventListener('change', () => {
        window.clearTimeout(timer);
        timer = window.setTimeout(updateResultCount, 180);
      });
      form.addEventListener('input', (event) => {
        if (event.target.type !== 'number') return;
        window.clearTimeout(timer);
        timer = window.setTimeout(updateResultCount, 180);
      });
      form.addEventListener('submit', () => {
        form.querySelectorAll('input[type="number"]').forEach((input) => {
          if (!input.value) input.disabled = true;
        });
      });
      state.cleanup = () => {
        window.clearTimeout(timer);
        if (aborter) aborter.abort();
        closeDrawer(state, true);
      };
    });
  };

  window.addEventListener('click', (event) => {
    const trigger = event.target instanceof Element && event.target.closest('[data-mfd-open]');
    if (!trigger) return;
    mount();
    const root = document.querySelector('[data-mfd-section]');
    const state = root && states.get(root);
    if (!state) {
      console.error('The custom filter drawer section is missing from this collection template.');
      return;
    }
    event.preventDefault();
    event.stopPropagation();
    openDrawer(state, trigger);
  }, true);

  document.addEventListener('shopify:section:load', (event) => {
    if (activeDialog && !activeDialog.root.isConnected) {
      editorDrawer = { id: activeDialog.root.dataset.mfdId, trigger: activeDialog.trigger };
      activeDialog.cleanup();
    }
    mount();
    if (!editorDrawer) return;
    const root = Array.from(event.target.querySelectorAll('[data-mfd-section]'))
      .find((element) => element.dataset.mfdId === editorDrawer.id);
    const state = root && states.get(root);
    if (!state) return;
    const trigger = editorDrawer.trigger && editorDrawer.trigger.isConnected
      ? editorDrawer.trigger : document.querySelector('[data-mfd-open]');
    editorDrawer = null;
    openDrawer(state, trigger, false);
  });
  document.addEventListener('shopify:section:select', (event) => {
    mount();
    const root = event.target.querySelector('[data-mfd-section]');
    const state = root && states.get(root);
    if (state) openDrawer(state, document.querySelector('[data-mfd-open]'));
  });
  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll('[data-mfd-section]').forEach((root) => {
      const state = states.get(root);
      if (state) {
        if (state.panel.open) editorDrawer = { id: root.dataset.mfdId, trigger: state.trigger };
        state.cleanup();
      }
      states.delete(root);
    });
  });

  window.CollectionFilterDialogs = { mount };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mount, { once: true });
  }
  mount();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["popup"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('editable-newsletter-popup')) {
  customElements.define('editable-newsletter-popup', class extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('dialog');
      this.key = 'editable-newsletter-popup-dismissed-' + this.dataset.sectionId;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.querySelector('[data-popup-close]').addEventListener('click', () => this.dismiss(), options);
      this.dialog.addEventListener('cancel', (event) => { event.preventDefault(); this.dismiss(); }, options);
      this.dialog.addEventListener('click', (event) => {
        if (event.target !== this.dialog) return;
        const box = this.dialog.getBoundingClientRect();
        if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) this.dismiss();
      }, options);
      document.addEventListener('shopify:section:select', (event) => { if (event.detail.sectionId === this.dataset.sectionId) this.open(true); }, options);
      document.addEventListener('shopify:section:deselect', (event) => { if (event.detail.sectionId === this.dataset.sectionId) this.dismiss(false); }, options);
      if (window.Shopify?.designMode) { if (this.dataset.enabled === 'true') this.open(true); return; }
      if (this.dataset.enabled !== 'true' || this.dataset.excluded === 'true') return;
      if (this.querySelector('[data-popup-success], [data-popup-error]')) { this.open(); return; }
      let last = 0;
      try { last = Number(localStorage.getItem(this.key)) || 0; } catch (error) {}
      if (Date.now() - last < Number(this.dataset.frequency) * 86400000) return;
      this.timer = setTimeout(() => this.open(), Number(this.dataset.delay) * 1000);
    }
    open(preview = false) {
      if (!this.isConnected || this.dialog.open) return;
      if (!preview && document.querySelector('dialog[open]')) { this.timer = setTimeout(() => this.open(), 1000); return; }
      this.previousFocus = document.activeElement;
      this.dialog.showModal();
      this.querySelector('[data-popup-close]').focus({ preventScroll: true });
    }
    dismiss(remember = true) {
      clearTimeout(this.timer);
      if (remember && !window.Shopify?.designMode) { try { localStorage.setItem(this.key, String(Date.now())); } catch (error) {} }
      this.dialog.close();
      if (this.previousFocus?.isConnected) this.previousFocus.focus({ preventScroll: true });
    }
    disconnectedCallback() { clearTimeout(this.timer); this.controller?.abort(); this.dialog?.close(); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["promotional-bar"] && !Shopify.designMode) return;
  try {
    
  class PromotionalBar extends HTMLElement {
    constructor() {
      super();

      const popupModal = this.querySelector('popup-modal');

      this.videos = this.querySelectorAll('[promotional-bar-video]');

      this.videos.forEach((video) => {
        video.addEventListener('click', () => {
          const videoId = video.getAttribute('data-id');
          console.log(videoId);
          popupModal.modalPopupOpen(`data-video-popup-${videoId}`);
        });
      });
    }
  }

  customElements.define('promotional-bar', PromotionalBar);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["recommended-products"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('sd-recommended-products')) {
  const recommendationRequests = new Map();
  function requestRecommendations(url) {
    if (!recommendationRequests.has(url)) {
      const controller = new AbortController();
      const timer = setTimeout(() => controller.abort(), 12000);
      const promise = fetch(url, {signal:controller.signal})
        .then(response => {
          if (!response.ok) throw new Error('Recommendations request failed');
          return response.text();
        })
        .finally(() => clearTimeout(timer));
      recommendationRequests.set(url, promise);
      if (recommendationRequests.size > 20) {
        recommendationRequests.delete(recommendationRequests.keys().next().value);
      }
    }
    return recommendationRequests.get(url);
  }
  customElements.define('sd-recommended-products', class extends HTMLElement {
    connectedCallback() {
      if (this.active) return;
      this.active = true;
      this.events = new AbortController();
      if (this.querySelector('.sdr__card')) {
        this.hidden = false;
        this.setup();
      } else if (this.dataset.url && !this.loading) {
        this.load();
      }
    }
    disconnectedCallback() {
      this.active = false;
      this.events?.abort();
      cancelAnimationFrame(this.frame);
      this.initialized = false;
    }
    async load() {
      this.loading = true;
      try {
        const html = await requestRecommendations(this.dataset.url);
        if (!this.isConnected) return;
        const inert = document.createElement('template');
        inert.innerHTML = html;
        const source = inert.content.getElementById(this.id);
        const inner = source?.querySelector('.sdr__inner');
        if (!inner?.querySelector('.sdr__card')) return;
        this.replaceChildren(inner.cloneNode(true));
        this.hidden = false;
        const note = document.querySelector(`[data-sdr-note="${this.dataset.section}"]`);
        if (note && !note.hidden) note.hidden = true;
        this.setup();
      } catch (error) {
        if (error.name !== 'AbortError') console.warn('Product recommendations could not load.', error);
      } finally {
        this.loading = false;
      }
    }
    setup() {
      if (this.initialized || !this.active) return;
      const track = this.querySelector('.sdr__track');
      const buttons = this.querySelectorAll('[data-step]');
      if (!track || buttons.length !== 2 || !track.children.length) return;
      this.initialized = true;
      const update = () => {
        if (!this.isConnected || !track.clientWidth) return;
        const cards = track.children;
        const box = track.getBoundingClientRect();
        const first = cards[0].getBoundingClientRect();
        const last = cards[cards.length - 1].getBoundingClientRect();
        const rtl = getComputedStyle(track).direction === 'rtl';
        const previousDisabled = rtl ? first.right <= box.right + 2 : first.left >= box.left - 2;
        const nextDisabled = rtl ? last.left >= box.left - 2 : last.right <= box.right + 2;
        if (buttons[0].disabled !== previousDisabled) buttons[0].disabled = previousDisabled;
        if (buttons[1].disabled !== nextDisabled) buttons[1].disabled = nextDisabled;
      };
      const schedule = () => {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(update);
      };
      buttons.forEach(button => button.addEventListener('click', () => {
        const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
        const rtl = getComputedStyle(track).direction === 'rtl';
        track.scrollBy({
          left:(track.firstElementChild.getBoundingClientRect().width + gap) * Number(button.dataset.step) * (rtl ? -1 : 1),
          behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'
        });
      }, {signal:this.events.signal}));
      track.addEventListener('scroll', schedule, {passive:true,signal:this.events.signal});
      window.addEventListener('resize', schedule, {passive:true,signal:this.events.signal});
      track.addEventListener('load', schedule, {capture:true,signal:this.events.signal});
      schedule();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["text-with-icon"] && !Shopify.designMode) return;
  try {
     
class Textwithicon extends HTMLElement{
  constructor() {
    super();
    const resizeObserver = new ResizeObserver(this.getHeight.bind(this));
    resizeObserver.observe(this);
    //this.getHeight();
  }
  getHeight(){
    this.divElement = this.querySelectorAll("[data-text-icon-desc]");
    this.divElement.forEach(element => {
      this.elemHeight = element.getBoundingClientRect().height;
      let closestParent = element.closest('[data-text-icon-inner]');
      if (closestParent) {
    
        closestParent.style.setProperty('--description_height', `${this.elemHeight}px`);
      }
    });
  }
}
customElements.define('text-with-icon', Textwithicon);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video"] && !Shopify.designMode) return;
  try {
     
class AnimatedCursor extends HTMLElement {
  constructor() {
    super();

    this.mouse = { x: -100, y: -100 };
    this.pos = { x: 0, y: 0 };
    this.speed = 0.15;
    this.element = null; // Keep track of the current element with cursor class

    
    //window.addEventListener('mousedown', this.startDrag.bind(this));
   // window.addEventListener('mouseup', this.endDrag.bind(this));

    const cursorPointer = this.closest('.section-video');

    if(! cursorPointer){ 
      cursorModifier.addEventListener('pointermove', this.removeCursor.bind(this));  
        return; 
      }
    // window.addEventListener('mousedown', this.startDrag.bind(this));
    cursorPointer.querySelectorAll('[cursor-class]').forEach((cursorModifier) => {
     cursorModifier.addEventListener('pointermove', this.updateCoordinates.bind(this));
      cursorModifier.addEventListener('mouseenter', this.addCursorClass.bind(this));
      cursorModifier.addEventListener('mouseleave', this.removeCursorClass.bind(this));
      cursorModifier.addEventListener('mouseout', this.removeCursor.bind(this));
      cursorModifier.addEventListener('scroll', () => {
        console.log('Scroll event fired');
      });
      cursorModifier.addEventListener('pointermove', this.removeCursor.bind(this));
      cursorModifier.addEventListener('mouseup', this.endDrag.bind(this));
      cursorModifier.addEventListener('mousedown', this.startDrag.bind(this)); // Add mousedown event here
    });

    requestAnimationFrame(this.loop.bind(this));
  }

  startDrag(e) {
    this.updateCoordinates(e);
  }

  endDrag(e) {
    this.updateCoordinates(e);
  }

  removeCursor(event) {
    this.element = event.currentTarget;
    const className = this.element.getAttribute('cursor-class');
    this.elementName = event.target.tagName;
  }

  handleScroll(e){
    console.log("wqewqe");
  }
  updateCoordinates(e) {
    this.mouse.x = e.clientX;
    this.mouse.y = e.clientY;
  }

  getAngle(diffX, diffY) {
    return (Math.atan2(diffY, diffX) * 180) / Math.PI;
  }

  getSqueeze(diffX, diffY) {
    const distance = Math.sqrt(Math.pow(diffX, 2) + Math.pow(diffY, 2));
    const maxSqueeze = 0.0;
    const accelerator = 1500;
    return Math.min(distance / accelerator, maxSqueeze);
  }

  updateCursor() {
    const diffX = Math.round(this.mouse.x - this.pos.x);
    const diffY = Math.round(this.mouse.y - this.pos.y);

    this.pos.x += diffX * this.speed;
    this.pos.y += diffY * this.speed;

    const angle = this.getAngle(diffX, diffY);
    const squeeze = this.getSqueeze(diffX, diffY);

    // Update cursor style with transformations
    this.style.translate = `${this.pos.x}px ${this.pos.y}px`;
    //this.style.transform = `scale(${2 + squeeze}, ${2 - squeeze}) rotate(${angle}deg) translate3d(${this.pos.x}px, ${this.pos.y}px, 0)`;
  }

  loop() {
    this.updateCursor();
    requestAnimationFrame(this.loop.bind(this));
  }

  addCursorClass(event) {
    this.element = event.currentTarget;
    const className = this.element.getAttribute('cursor-class');
    if (className === 'video') {
      this.classList.add('king_cursor');
      this.videoButton = this.element.querySelector('[data-content-button]');
     
      if(this.videoButton){
      this.videoButton.style.display = "none";
      }
      this.innerHTML = this.videoButton.innerHTML;
    }
  }

  removeCursorClass(event) {
    const element = event.currentTarget;
    console.log(element);
    const className = element.getAttribute('cursor-class');
    if (className === 'video') {
      this.videoButton = this.element.querySelector('[data-content-button]');
      if(this.videoButton){
      this.videoButton.style.display = "block";
      }
      this.innerHTML = '';
      this.classList.remove('king_cursor');
    }
  }
}

customElements.define('animated-cursor', AnimatedCursor);


  } catch(e) { console.error(e); }
})();
})();
